import React, { MouseEvent } from 'react';

type CommentRemovalPaneProps = {
  onCancelRemovingComment: () => void,
  onRemoveComment: (e?: MouseEvent, reason?: string) => void,
  hasSources: boolean,
  savingSubmission: boolean
}

const CommentRemovalPane: React.FC<CommentRemovalPaneProps> = ({
  onCancelRemovingComment, onRemoveComment, hasSources, savingSubmission
}) => {
  const { Annotator } = window;

  const cancelClick = (e: MouseEvent) => {
    e.preventDefault();
    onCancelRemovingComment();
  };

  const removeClick = (e: MouseEvent, reason?: string) => {
    e.preventDefault();
    onRemoveComment(e, reason);

    // Update feedback helper contents
    setTimeout(() => { Annotator.updateFeedbackHelperContents(); }, 0);
  };

  const label = hasSources ? ' citation highlight?' : ' annotation?';

  return (
    <div className="overlay RemovalPane text-center d-flex flex-column justify-content-center">
      <p className="text-center">
        <strong>
          Remove this
          {label}
        </strong>
      </p>
      <div className="d-flex justify-content-around align-items-center">
        <button
          type="button"
          className="btn-plaintext white"
          disabled={savingSubmission}
          onClick={cancelClick}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-danger"
          disabled={savingSubmission}
          onClick={removeClick}
          onMouseDown={(e: MouseEvent) => e.preventDefault()}
        >
          Yes, Delete it.
        </button>
      </div>
    </div>
  );
};

export default CommentRemovalPane;
